import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useAutoLogout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const logoutTimer = 30 * 60 * 1000; // 30 minutes

        const resetTimer = () => {
            clearTimeout(window.autoLogoutTimer);
            window.autoLogoutTimer = setTimeout(() => {
                handleLogout();
            }, logoutTimer);
        };

        const handleLogout = () => {
            localStorage.clear();
            sessionStorage.clear();
            navigate("/login");
        };

        // Event listeners to track user activity
        window.addEventListener("mousemove", resetTimer);
        window.addEventListener("keydown", resetTimer);

        window.autoLogoutTimer = setTimeout(() => {
            handleLogout();
        }, logoutTimer);

        return () => {
            clearTimeout(window.autoLogoutTimer);
            window.removeEventListener("mousemove", resetTimer);
            window.removeEventListener("keydown", resetTimer);
        };
    }, [navigate]);
};

export default useAutoLogout;
